<div class="title">
  <mat-icon>person</mat-icon>
  Team
</div>
<div class="description">SELECT THE TEAMS TO FILTER BY</div>

<div class="options">
  @for (team of teams$ | async; track team) {
    <elements-filter-chip
      icon="people"
      [caption]="team.displayName"
      [selected]="isSelected(team)"
      (click)="isSelected(team) ? remove(team) : add(team)"
      [suffixIcon]="isSelected(team) ? 'close' : undefined"
      >
    </elements-filter-chip>
  }
</div>

<div class="actions">
  <button styles-button (click)="close.emit()">Filter</button>
  <button styles-low-button (click)="clear()">Clear</button>
</div>
